import { render } from "./FavCardMatch.vue?vue&type=template&id=13363594&scoped=true"
import script from "./FavCardMatch.vue?vue&type=script&lang=js"
export * from "./FavCardMatch.vue?vue&type=script&lang=js"

import "./FavCardMatch.vue?vue&type=style&index=0&id=13363594&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-ASPN/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13363594"]])

export default __exports__